import type { ErrorInfo, JSX } from 'react'

import { ErrorDescription } from "/app/libraries/arcana/src/blocks/ErrorDescription/index.ts"

import { locationAssign } from '~/core/router'
import { PageWrapper } from '~/core/skin/ui'
import { logger } from '~/shared/logger'
import { captureException } from '~/shared/sentri'
import { NavBar } from '~/widgets/NavBar'

interface Props {
  error: unknown
}

ErrorFallback.displayName = 'ErrorFallback'
export function ErrorFallback({ error }: Props): JSX.Element {
  const errorMessage =
    error instanceof Error ||
    (typeof error === 'object' && error !== null && 'message' in error)
      ? String(error.message || error)
      : String(error)

  const returnToHomePage = () => locationAssign('/')

  return (
    <>
      <NavBar />
      <PageWrapper>
        <ErrorDescription
          error={errorMessage}
          handleButtonClick={returnToHomePage}
          buttonTitle={'Back to Home page'}
        />
      </PageWrapper>
    </>
  )
}

export function errorHandler(error: unknown, info: ErrorInfo): void {
  logger.error('❤️‍🩹', error, info)
  captureException([
    error,
    {
      tags: {
        source: 'react-error-boundary',
      },
      extra: {
        componentStack: info.componentStack,
      },
    },
  ])
}
